import splitProps from './split-props';
export default splitProps;
